function applyRegiosRangeDiscounts(apiV0, sectionId) {
    if (!apiV0) {
        console.error('RegiosDOPP API v0 is not available.');
        return;
    }

    // Use the Regios formatter if available, otherwise fall back to Shopify's default.
    const formatPriceInCents = (priceInCents) => {
        // 1. Try to use the Regios formatter (which was failing)
        if (apiV0.themeInterop && typeof apiV0.themeInterop.formatMoney === 'function') {
            return apiV0.themeInterop.formatMoney(priceInCents);
        }

        // 2. Fallback to Shopify's global formatMoney utility
        if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
             // If this still fails, may need to define Shopify.money_format somewhere.
             return Shopify.formatMoney(priceInCents, Shopify.money_format || '${{amount}}'); 
        }

        // 3. Absolute fallback (if no formatter is found, just return cents as a string)
        return `$${(priceInCents / 100).toFixed(2)}`;
    };

    const dataScript = document.getElementById(`RegiosDoppProductData-${sectionId}`);
    if (!dataScript) {
        console.error(`Could not find product data for section ${sectionId}.`);
        return;
    }

    let productsData;
    try {
        productsData = JSON.parse(dataScript.textContent);
    } catch (e) {
        console.error('Failed to parse product data JSON.', e);
        return;
    }

    productsData.forEach(product => {
        const productElement = document.querySelector(`[data-regios-dopp-generic-product-id="${product.id}"]`);
        if (!productElement) {
            return;
        }

        const salePriceElement = productElement.querySelector('.regios-dopp-generic-price-item--sale');
        const originalPriceElement = productElement.querySelector('.regios-dopp-generic-price-item--regular');
        
        if (!salePriceElement) {
            console.warn(`Regios DOPP: Sale price element (.regios-dopp-generic-price-item--sale) NOT FOUND for product ${product.id}. Skipping update.`);
            return;
        }

        const variantPricePromises = product.variants.map(variant => {
            const args = {
                productId: product.id,
                variantId: variant.id,
                regularPriceInCents: variant.price, 
                collectionIds: product.collectionIds,
                handle: product.handle,
                url: product.url,
                variants: product.variants,
            };
            
            return apiV0.calculateDiscountedPrices(args);
        });

        Promise.all(variantPricePromises)
            .then(results => {
                
                let minSalePrice = Infinity;
                let maxSalePrice = -Infinity;
                let hasDiscount = false;
                
                let minRegularPrice = Infinity;
                let maxRegularPrice = -Infinity;

                results.forEach(result => {
                    // Convert dollar amounts (float) from API response to cents (integer)
                    const salePriceInCents = Math.round(result.salePrice.amount * 100);
                    const regularPriceInCents = Math.round(result.regularPrice.amount * 100);
                    
                    if (salePriceInCents < regularPriceInCents) {
                        hasDiscount = true;
                    }
                    
                    minSalePrice = Math.min(minSalePrice, salePriceInCents);
                    maxSalePrice = Math.max(maxSalePrice, salePriceInCents);
                    
                    minRegularPrice = Math.min(minRegularPrice, regularPriceInCents);
                    maxRegularPrice = Math.max(maxRegularPrice, regularPriceInCents);
                });

                // --- DOM UPDATE LOGIC ---
                if (hasDiscount) {
                    // 1. Update the Current/Sale Price Element
                    const minFormattedSale = formatPriceInCents(minSalePrice);
                    const maxFormattedSale = formatPriceInCents(maxSalePrice);

                    const newSalePriceHTML = minSalePrice !== maxSalePrice
                        ? `${minFormattedSale} - ${maxFormattedSale}`
                        : minFormattedSale;
                    
                    salePriceElement.innerHTML = newSalePriceHTML; // Correctly uses the selected <strong> element

                    // 2. Update the Strikethrough/Regular Price Element
                    if (originalPriceElement) {
                        if (minRegularPrice !== minSalePrice || maxRegularPrice !== maxSalePrice) {
                            
                            const minFormattedRegular = formatPriceInCents(minRegularPrice);
                            const maxFormattedRegular = formatPriceInCents(maxRegularPrice);
                            
                            const newRegularPriceHTML = minRegularPrice !== maxRegularPrice
                                ? `${minFormattedRegular} - ${maxFormattedRegular}`
                                : minFormattedRegular;
                                
                            originalPriceElement.innerHTML = newRegularPriceHTML;
                            
                            // Remove hidden classes to show the strikethrough price
                            originalPriceElement.classList.remove('hidden', 'hide'); 

                            // Add sale class to wrapper
                            const priceContainer = productElement.querySelector('.price');
                            if(priceContainer) {
                                priceContainer.classList.add('price--on-sale');
                            }
                        } else {
                             // Hide strikethrough if no true discount difference is found
                             originalPriceElement.classList.add('hidden', 'hide');
                        }
                    }
                }
            })
            .catch(e => console.error(`Error calculating prices for product ${product.id}:`, e));
    });
}

// ---------------------------------------------
// Initialization Check (Wrapped in an IIFE)
// ---------------------------------------------
(function() {
    // Get the ID from the data attribute added in Liquid
    const currentScript = document.currentScript;
    const sectionId = currentScript ? currentScript.dataset.regiosDoppSectionId : null;
    
    // Check for illegal return and use the IIFE scope to safely exit
    if (!sectionId) {
        console.error("RegiosDOPP: Failed to retrieve section ID from the script tag.");
        return; 
    }
    
    if (window.RegiosDOPP?.api?.v0) {
        // API is already available, run the function immediately
        applyRegiosRangeDiscounts(window.RegiosDOPP.api.v0, sectionId);
    } else {
        // API is not yet available, listen for the initialization event
        window.addEventListener("regios-dopp:api-initialized", (event) => {
            applyRegiosRangeDiscounts(event.detail.api, sectionId);
        });
    }
})();